export enum PricingTypeEnum {
  FIXED = 'FIXED',
  TOGGLE = 'TOGGLE',
}
